import { render, staticRenderFns } from "./alltypeselect.vue?vue&type=template&id=0c6a1a9a&scoped=true"
import script from "./alltypeselect.vue?vue&type=script&lang=js"
export * from "./alltypeselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6a1a9a",
  null
  
)

export default component.exports